export default "__VITE_PUBLIC_ASSET__0dc92d01__"